import { useEffect, useState } from "react";
import { api, fmtPHP, fmtDate } from "@/lib/api";
import { PCard } from "@/components/portal/PortalBits";
import { ArrowDownLeft } from "lucide-react";

export default function PortalHistory() {
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/portal/payments").then((r) => setList(r.data));
  }, []);
  return (
    <div data-testid="portal-history-page" className="space-y-4">
      <h1 className="font-display text-2xl font-bold text-slate-900">Transaction history</h1>
      <PCard className="p-1">
        {!list && <div className="text-center text-slate-400 py-6">Loading…</div>}
        {list?.length === 0 && <div className="text-center text-sm text-slate-500 py-6">No transactions yet.</div>}
        {list?.map((p) => (
          <div key={p.id} className="flex items-center gap-3 p-3 border-b border-slate-100 last:border-0" data-testid={`history-txn-${p.id}`}>
            <span className="h-9 w-9 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center">
              <ArrowDownLeft className="h-4 w-4" />
            </span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-900">{p.method} payment</div>
              <div className="text-[11px] text-slate-500 truncate">{p.receipt_no} · {fmtDate(p.paid_at)}{p.reference ? ` · Ref ${p.reference}` : ""}</div>
            </div>
            <div className="text-sm font-bold text-emerald-600">{fmtPHP(p.amount)}</div>
          </div>
        ))}
      </PCard>
    </div>
  );
}
